import { emitEvent } from "./emit-event";
import { EVENT_TYPE } from "./events";

htmx.onLoad(rootElement => {
  // Track general booking button clicks
  rootElement.querySelectorAll("[data-booking-button]").forEach(button =>
    button.addEventListener("click", e => {
      const target = e.currentTarget as HTMLAnchorElement;

      if (target.href) {
        const url = new URL(target.href);

        emitEvent(
          EVENT_TYPE.bookingClick,
          { bookingSource: url.hostname, bookingUrl: target.href },
          false
        );
      }
    })
  );
});
